import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=246c6f57&"
import script from "./RoleCreate.vue?vue&type=script&lang=js&"
export * from "./RoleCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&id=246c6f57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports